module.exports = __webpack_public_path__ + "static/media/YTILynx.efd128d7.png";